/**
 * Centralized branding configuration.
 * All user-facing brand references should import from this module
 * so renames/rebrands are a single-file change.
 */

const FRONTEND_BASE_URL =
  process.env.REACT_APP_FRONTEND_BASE_URL ||
  (typeof window !== 'undefined' ? window.location.origin : '');

const branding = {
  appName: 'a-Professional',
  appTagline: "South Africa's home for trusted professionals",
  supportEmail: 'support@a-professional.com',
  domain: 'app.a-professional.com',
  frontendBaseUrl: FRONTEND_BASE_URL,
  copyright: `© ${new Date().getFullYear()} a-Professional. All rights reserved.`,
  brandColor: '#37b34a',
  brandColorDark: '#2d9a3e',
};

export default branding;
export const {
  appName,
  appTagline,
  supportEmail,
  domain,
  frontendBaseUrl,
  copyright,
  brandColor,
  brandColorDark,
} = branding;
